import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuotesHistoryComponent } from './quotes-history.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { QuotesHistoryFormComponent } from './quotes-history-form/quotes-history-form.component';
import { QuotesHistoryDetailsComponent } from './quotes-history-details/quotes-history-details.component';
import { PageSlotModule } from '@spartacus/storefront';
import { PageTitle } from '../../store-front/misc/page-title/page-title.component';

@NgModule({
  declarations: [QuotesHistoryComponent],
  imports: [CommonModule, QuotesHistoryFormComponent, QuotesHistoryDetailsComponent, PageSlotModule, PageTitle],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        QuotesHistoryPageComponent: {
          component: QuotesHistoryComponent,
        },
      },
    }),
    provideConfig({
      routing: {
        routes: {
          quotesHistory: { paths: ['quotes-history/:id'] },
        },
      },
    }),
  ],
})
export class QuotesHistoryModule {}
